var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wgt-article-waterfall",style:(_vm.setstyle)},[_c('ArticleWaterfall',{key:`normal-waterfall-${_vm.normalListSignature}`,attrs:{"list":_vm.normalDisplayList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }